
export async function glideVideoInit() {
    const elements = document.querySelectorAll('.glide--video');
    if (elements.length) {
        let {default: Glide, Breakpoints, Controls, Swipe} = await import('@glidejs/glide/dist/glide.modular.esm');
        elements.forEach(element => {
            const glide = new Glide(element, {
                // type: 'carousel',
                gap: '30px',
                perView: 2,
                bound: true,
                breakpoints: {
                    768: {
                        perView: 1
                    }
                }
            })

            glide.mount({Controls, Breakpoints, Swipe});

            element.addEventListener('mouseover', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'block';
                });
            });
    
            element.addEventListener('mouseout', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'none';
                });
            });
        });
    }
}